import React, { useState } from 'react';
import { customerAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { Gift } from 'lucide-react';

export default function CustomerRefer() {
  const [form, setForm] = useState({ name: '', address: '', mobile: '', serviceType: 'broadband' });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await customerAPI.submitReferral(form);
      toast.success('Thanks! Our team will reach out to them soon.');
      setForm({ name: '', address: '', mobile: '', serviceType: 'broadband' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to submit referral');
    } finally { setSubmitting(false); }
  };

  return (
    <div>
      <div className="mb-6">
        <h2 style={{ fontSize: '1.2rem', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}>
          <Gift size={20} color="#d97706" /> Refer & Earn
        </h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '.85rem' }}>
          Know someone who wants CableTV or Broadband? Share their details and our team will take it from there.
        </p>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Their Name *</label>
              <input className="form-control" value={form.name}
                onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
            </div>
            <div className="form-group">
              <label className="form-label">Their Address *</label>
              <input className="form-control" value={form.address}
                onChange={e => setForm(f => ({ ...f, address: e.target.value }))} required />
            </div>
            <div className="form-group">
              <label className="form-label">Their Mobile Number *</label>
              <input className="form-control" type="tel" value={form.mobile}
                onChange={e => setForm(f => ({ ...f, mobile: e.target.value }))} required />
            </div>
            <div className="form-group">
              <label className="form-label">Service *</label>
              <select className="form-control" value={form.serviceType}
                onChange={e => setForm(f => ({ ...f, serviceType: e.target.value }))}>
                <option value="broadband">Broadband</option>
                <option value="catv">CableTV</option>
              </select>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button type="submit" className="btn btn-primary" disabled={submitting}>
                {submitting ? 'Submitting...' : 'Submit Referral'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
